import axios from "axios";

const survivorshipDomainBusinessRulesURL =
  "/api/v1/survivorship_domain_business_rules";

const fetchRules = (page = 1, pageSize = 10, sort, filters) =>
  axios.get(survivorshipDomainBusinessRulesURL, {
    params: { page, per_page: pageSize, sort, filters },
  });

const addNewRule = payload =>
  axios.post(survivorshipDomainBusinessRulesURL, {
    survivorship_domain_business_rules: payload,
  });

const updateRule = (id, payload) =>
  axios.put(`${survivorshipDomainBusinessRulesURL}/${id}`, {
    survivorship_domain_business_rules: payload,
  });

const deleteRule = id =>
  axios.delete(`${survivorshipDomainBusinessRulesURL}/${id}`);

const fetchRuleTypes = filters =>
  axios.get(`${survivorshipDomainBusinessRulesURL}/business_rule_types`, {
    params: { filters },
  });

const fetchDomains = filters =>
  axios.get(`${survivorshipDomainBusinessRulesURL}/domains`, {
    params: { filters },
  });

const fetchCdes = filters =>
  axios.get(`${survivorshipDomainBusinessRulesURL}/cdes`, {
    params: { filters },
  });

const fetchContexts = filters =>
  axios.get(`${survivorshipDomainBusinessRulesURL}/contexts`, {
    params: { filters },
  });

const survivorshipDomainBusinessRulesApi = {
  fetchRules,
  addNewRule,
  updateRule,
  deleteRule,
  fetchRuleTypes,
  fetchDomains,
  fetchCdes,
  fetchContexts,
};

export default survivorshipDomainBusinessRulesApi;
